import { render, staticRenderFns } from "./ReceiptSettings.vue?vue&type=template&id=27950af4&scoped=true&"
import script from "./ReceiptSettings.vue?vue&type=script&lang=js&"
export * from "./ReceiptSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptSettings.vue?vue&type=style&index=0&id=27950af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27950af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27950af4')) {
      api.createRecord('27950af4', component.options)
    } else {
      api.reload('27950af4', component.options)
    }
    module.hot.accept("./ReceiptSettings.vue?vue&type=template&id=27950af4&scoped=true&", function () {
      api.rerender('27950af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/ReceiptSettings.vue"
export default component.exports